import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./PriceMatching.css";
import { Helmet } from "react-helmet";

class PriceMatching extends Component {
  render() {
    return (
      <div id="price-matching-page">
        <Helmet>
          <title>Price Matching - HelloAva</title>
        </Helmet>
        <div className="price-matching-body">
          <div className="price-matching-header">
            <img
              alt="Price matching"
              src="/images/onboarding/price-match.svg"
            />
            <div className="title">Price Matching</div>
          </div>

          <div className="title">Send Us An Email</div>
          <p>
            If you find a lower price from another
            online retailer on an Eligible Product, tell us and we'll match it.
            Reach out to us at{" "}
            <a href="mailto:customersuccess@helloava.co">
              customersuccess@helloava.co
            </a>
            , and we'll match the lowest price. We want you to purchase
            with us, so that you get all our amazing benefits, like getting the
            personalized skincare advice and having a personal esthetician at
            your speed dial.
          </p>

          <div className="title">What is an Eligible Product</div>
          <p>
            We will price-match on items that meet the following criteria: we
            will adjust prices for in-stock items only on HelloAva. The product
            being matched must be an identical item to the product on our
            platform: brand name, size, weight, color, and model/style number
            must match. The product must be in stock at the other online
            retailer at the time of the price match. Price matching is only
            available within 48 hours after the time of purchase if you want to
            retroactively price match.
          </p>

          <div className="title">What Limitations or Exceptions are there?</div>
          <p>
            The following limitations and exceptions apply: the price for an
            item/offer must be listed online and valid at the time of the price
            match. It cannot be a price that is achieved with a discount code.
            We reserve the right to verify a competitor’s advertised price and
            product details, as well as to confirm the product is in stock at
            the competitor. Excludes promotional prices including Thanksgiving
            through The Monday after Thanksgiving. Excludes on-sale items,
            clearance, closeout, liquidation sales, damaged, used, open package,
            refurbished, pre-owned, or rent/lease to own items, mail-in rebates,
            storewide or unspecific offers, non-branded items, or prices that
            only display on a website after guests log in. Pricing typographical
            errors, limited time or quantity offers, daily deals, coupon offers,
            credit card offers, gift card offers, financing, service offers,
            bundled offers, sales tax promotions, free items, rebates or mail-in
            offers are not eligible for match. Excludes “Marketplace” prices
            (such as eBay or Amazon) and prices from third party sellers.
            Excludes catalogue prices and off-line retail store prices. All
            matches are done against pre-tax prices; guest is responsible for
            applicable taxes which are calculated on the pre-discount price.
          </p>
          <strong>
            HelloAva has the final decision for matching an online price.
          </strong>
        </div>
      </div>
    );
  }
}

export default withRouter(PriceMatching);



// WEBPACK FOOTER //
// ./src/views/pricematching/PriceMatching.js